import { CSSProperties, FC, PropsWithChildren } from 'react';

import { TColorProp } from 'styled-components';

import { satoshi } from '~/common/styles/fonts';

import { Container, TLabelSize } from './styles';

interface ILabelProps extends PropsWithChildren {
  size: TLabelSize;
  color?: TColorProp;
  style?: CSSProperties;
  href?: string;
  title?: string;
  onClick?: () => void;
}

export const Label: FC<ILabelProps> = ({
  size,
  color = 'neutral900',
  children,
  style,
  href,
  title,
  onClick,
}) => {
  return (
    <Container
      $size={size}
      $color={color}
      className={satoshi.className}
      style={style}
      title={title}
      {...(onClick && {
        onClick,
      })}
      {...(href && {
        as: 'a',
        href,
      })}
    >
      {children}
    </Container>
  );
};
